<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      highlight-current-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 42"
      size="small"
      resizable
      border
      row-id="materialTemplateCode"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :tree-config="{ children: 'children', reserve: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.templateStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.templateStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.materialTemplateCode
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.materialTemplateCode
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.templateStatus === 'Y'"
            v-if="allow('D')"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.materialTemplateCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 110,
          slots: {
            default: 'opt'
          }
        },
        {
          title: this.$l('table_label_fieldName') || '字段名称',
          field: 'fieldName',
          minWidth: 120,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          title: this.$l('table_label_control_chinese_title') || '控件中文标题',
          field: 'controlLabelText',
          minWidth: 120,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          title: this.$l('table_label_control_english_title') || '控件英文标题',
          field: 'controlLabelTextEn',
          minWidth: 120,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          title: this.$l('table_label_controlType') || '控件类型',
          field: 'controlTypeName',
          width: 120,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          title: this.$l('table_label_isRequired') || '是否必输项',
          field: 'isRequiredName',
          width: 120,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          title: this.$l('table_label_sortOrder') || '字段顺序',
          field: 'sortOrder',
          width: 120,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          title: this.$l('table_label_control_row') || '控件所在行',
          field: 'rowNo',
          width: 120,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          title: this.$l('table_label_control_width') || '控件宽度',
          field: 'colSpan',
          width: 120,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          title: this.$l('table_label_control_json') || '控件属性定义json',
          field: 'controlProps',
          minWidth: 150,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          field: 'templateStatus',
          align: 'center',
          width: 120,
          title: this.$l('INDEX.Status') || '有效状态',
          slots: { default: 'status' },
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          field: 'createByName',
          align: 'center',
          minWidth: 120,
          title: this.$l('INDEX.creator') || '创建人',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          field: 'createDate',
          align: 'center',
          minWidth: 170,
          title: this.$l('INDEX.table_label_created_date') || '创建时间',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          field: 'modifyByName',
          align: 'center',
          minWidth: 120,
          title: this.$l('INDEX.table_label_modified_by') || '修改人',
          showHeaderOverflow: 'title',
          showOverflow: true
        },
        {
          field: 'modifyDate',
          align: 'center',
          minWidth: 170,
          title: this.$l('INDEX.table_label_modification_date') || '修改时间',
          showHeaderOverflow: 'title',
          showOverflow: true
        }
      ]
    }
  },
  methods: {
    del(materialTemplateCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$api
          .materialTemplateDelApi({ materialTemplateCode })
          .then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || res.msg,
              type: 'success'
            })
            this.$emit('reload')
          })
      })
    }
  }
}
</script>
